import {parseQueryString} from '../../libs/shared/helpers/src/browser/urlHelpers';
import {parseMailto} from '../../srcCommon/helpers/mailtoHelpers';
import {MailtoOptions} from '../../srcCommon/helpers/mailtoHelpersCommon';

interface LocationLike {
  search: string;
}

export function parseMailToFromLocation(location: LocationLike): MailtoOptions | undefined {
  // We may already have the mailto string parsed as it can be passed in as:
  //   mailto:name1@mail.com,name2@mail.com?subject=test&body=test
  // so we can check if the parsed "mailto:" is present.
  const {mailto} = location?.search.includes('mailto:')
    ? {mailto: location?.search.split('mailto=')[1]}
    : parseQueryString(location?.search || '');

  if (!mailto) {
    return undefined;
  }

  return parseMailto(mailto);
}
